/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from "react";


// CSS styles for modal
const modalOverlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
};

const modalStyle: React.CSSProperties = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    width: '500px',
    maxHeight: '90%',
    overflowY: 'auto',
    position: 'relative',
    textShadow: 'none',
    color: 'black',
    fontFamily: 'arial',
    textAlign: 'left',
    fontSize: 'x-small'
};


interface PrivacyNoticeProps {
    onClose: () => void
}

const PrivacyNotice: React.FC<PrivacyNoticeProps> = ({onClose}) => {
    return (
      <div style={modalOverlayStyle}>
        <div style={modalStyle}>
            <h2>Privacy Policy</h2>
            Effective Date: Dec 3rd, 2024<br/>
            Green God Games, LLC values your privacy.
            This Privacy Policy explains how we collect, use, and protect your information when you use our website and services.
            <ol>
                <li>
                    <b>Information We Collect:</b><br/>
                    <ul>
                        <li>
                            <b>Email Address:</b> We collect your email address when you create an account through Firebase Authentication.
                        </li>
                        <li>
                            <b>Date of birth:</b> We collect your birthday only to verify your age meets our minimum age policies.
                        </li>
                    </ul>
                </li>
                <li> <b>How We Use Your Information</b><br/>
                    We use your email address for the following purposes: <br/>
                    <ul>
                        <li>To send account-related emails, such as password reset instructions.</li>
                        <li>To notify you about critical updates or changes to our website (very rarely).</li>
                        <li>We will never sell or share your email address with third parties for marketing or other purposes.</li>
                    </ul>
                </li>
                <li> <b>Future Updates</b><br/>
                    If we introduce optional features like a monthly newsletter in the future, you will have the choice to opt in to receive such communications.
                    We will only send these communications with your explicit consent.
                </li>
                <li> <b>Your Rights</b><br/>
                    You have the following rights regarding your information:<br/>
                    <b>Access and Update:</b> You can access and update your account information at any time.<br/>
                    <b>Email Preferences:</b> You can opt-out of non-essential emails (e.g., newsletters) at any time by following the unsubscribe link in such emails.
                </li>
                <li> <b>Data Protection</b><br/>
                    We take appropriate security measures to protect your email address and other account information from unauthorized access, alteration, disclosure, or destruction.
                    However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.
                </li>
                <li> <b>Third-Party Services</b><br/>
                    We use Firebase Authentication to manage user accounts. Firebase's privacy practices are outlined in their Privacy Policy.<br/>
                    We do not share your information with third parties, except as required by law.
                </li>
                <li> <b>Children's Privacy</b><br/>
                    Our website is not intended for children under 13, and they are not permitted to create an account.
                    We do not knowingly collect personal information from children.
                    If you believe we have inadvertently collected information from a child, please contact us immediately at <a href="mailto:support@GreenGodGames.com" target="_blank" rel="noreferrer">support@GreenGodGames.com</a>.
                </li>
                <li> <b>Response to Legal Demands for information</b><br/>
                    We comply with valid legal requests for information from verified legal authorities.
                    Each request is carefully reviewed to ensure compliance with applicable laws before any data is released.
                    We maintain a detailed log of all such requests, including the information disclosed, the legal basis for the disclosure, and the parties involved.
                </li>
                <li> <b>Changes to This Privacy Policy</b><br/>
                    We may update this Privacy Policy from time to time to reflect changes to our practices or for legal or regulatory reasons.
                    We encourage you to review this page periodically for the latest information.
                </li>
                <li> <b>Contact Us</b><br/>
                    If you have any questions about this Privacy Policy, please contact us at:<br/>
                    Email: <a href="mailto:support@GreenGodGames.com" target="_blank" rel="noreferrer">support@GreenGodGames.com</a>
                </li>
            </ol>
            <br/>
            <div style={{textAlign: 'right'}}>
                <button onClick={() => onClose()}>Close</button>
            </div>
        </div>
     </div>
    );
  };
  
  export default PrivacyNotice;
  